import { Container, Row, Col, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { PRIMARY_BUTTON_STYLE } from "constants/theme";

interface ComingSoonProps {
    title: string;
    description: string;
    icon?: string;
}

const ComingSoon = ({ title, description, icon = "ni ni-building" }: ComingSoonProps) => {
    const navigate = useNavigate();

    return (
        <section
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: "80vh", paddingTop: "140px", paddingBottom: "60px" }}
        >
            <Container>
                <Row className="justify-content-center text-center">
                    <Col lg="7">
                        <div
                            className="d-inline-flex align-items-center justify-content-center mb-4"
                            style={{
                                width: "72px",
                                height: "72px",
                                borderRadius: "50%",
                                backgroundColor: "rgba(15,118,110,0.1)",
                            }}
                        >
                            <i className={icon} style={{ fontSize: "2rem", color: "#0F766E" }} />
                        </div>

                        <span className="badge badge-pill badge-secondary mb-3">Coming soon</span>
                        <h1 className="display-3 font-weight-bold mb-3">{title}</h1>
                        <p className="h5 text-muted font-weight-light mb-5">{description}</p>

                        <Button
                            style={{ ...PRIMARY_BUTTON_STYLE, borderRadius: "999px", padding: "0.75rem 2rem" }}
                            onClick={() => navigate("/jobs")}
                        >
                            Browse Energy Jobs
                        </Button>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ComingSoon;
